import { createSelector } from 'reselect';

import createConsentMask from 'services/consents-management/DidomiSDK/utils/createConsentMask.ts';
import fallbackConsentOrdering from 'services/consents-management/consentOrdering.ts';

import { ReduxStore } from '../types';
import { requestFailure, requestSuccess } from '../utils';

export function selectApiConfig(store: ReduxStore) {
    return store.config.api;
}

export function selectAppConfig(store: ReduxStore) {
    return store.config.app;
}

export function selectConfig(store: ReduxStore) {
    return store.config;
}

export function selectLayoutConfig(store: ReduxStore) {
    return store.config.layout;
}

export function selectIfLanguagesRequestSuccess(store: ReduxStore) {
    return requestSuccess(store.config.getLanguagesRequest.status);
}

export const selectIfLanguagesRequestFailure = createSelector(
    selectConfig,
    (config) => requestFailure(config.getLanguagesRequest.status),
);

export function selectAppState(store: ReduxStore) {
    return store.config.appState;
}

export function selectInitialWebPathParams(store: ReduxStore) {
    return store.config.initialWebPathParams;
}

export function selectReduceMotionEnabled(store: ReduxStore) {
    return store.config.reduceMotionEnabled;
}

export function selectScreenReaderEnabled(store: ReduxStore) {
    return store.config.screenReaderEnabled;
}

export function selectConsentOrdering(store: ReduxStore) {
    return store.config.consentOrdering || fallbackConsentOrdering;
}

export function selectDidomiUserStatus(store: ReduxStore) {
    return store.config.didomiUserStatus;
}

export const selectConsentMask = createSelector(
    selectConsentOrdering,
    selectDidomiUserStatus,
    createConsentMask,
);

export function selectSplashScreenState(store: ReduxStore) {
    return store.config.splashScreen;
}
